import script from "./PartFive.vue?vue&type=script&setup=true&lang=js"
export * from "./PartFive.vue?vue&type=script&setup=true&lang=js"

import "./PartFive.vue?vue&type=style&index=0&id=01c37602&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c37602"]])

export default __exports__